export const dialogSelector = state => state.dialogs;
